import { collection, findSelector, resource } from "data/helpers/apiv3";
import { GoalParticipantTrip } from "data/records";

const [api, actions] = resource(GoalParticipantTrip, [["list", collection.get("", ["goalId", "userId"])]]);

const selectors = {
  ...findSelector(GoalParticipantTrip),
  byGPId: (state, gPId) => state.apiv3.goalParticipantTrip.id.filter((gpt) => gpt.goalParticipantId === gPId),
};

const reducers = {};

const initialState = {};

export {
  api as goalParticipantTripApi,
  actions as goalParticipantTripActions,
  selectors as goalParticipantTripSelectors,
  reducers as goalParticipantTripReducers,
  initialState as goalParticipantTripInitialState,
};
